import React, { useEffect, useRef, useState } from "react";

import { LinearProgress } from "@mui/material";

const DEFAULT_TEXT = [
  "Extracting audio samples",
  "Loading artist vocals",
  "Voice cloning in progress",
];

const ProgressBar: React.FC<{
  totalSeconds: number;
  isLoadingComplete?: boolean;
  textToDisplay?: string[];
}> = ({ totalSeconds, isLoadingComplete, textToDisplay = DEFAULT_TEXT }) => {
  const interval = useRef<NodeJS.Timeout>();

  const [totalTime] = useState(totalSeconds);
  const [loadingText] = useState(textToDisplay);
  const [progressBarValue, setProgressBarValue] = useState(1);

  useEffect(() => {
    if (!isLoadingComplete) {
      return;
    }

    setProgressBarValue(100);
    clearInterval(interval.current);
  }, [isLoadingComplete]);

  useEffect(() => {
    let count = 0;

    interval.current = setInterval(() => {
      if (count / totalTime < 0.8) {
        count++;
      } else {
        count += 0.2;
      }

      const _count = count * 100;
      const _totalTime = totalTime * 100;
      const newProgressBarValue = (_count / _totalTime) * 100;

      setProgressBarValue(newProgressBarValue > 95 ? 95 : newProgressBarValue);
    }, 1000);

    return () => {
      clearInterval(interval.current);
    };
  }, [totalTime]);

  const percentageComplete = `${Math.floor(progressBarValue)}%`;

  const textIndex = Math.floor(progressBarValue / (100 / loadingText.length));
  const text =
    textIndex > loadingText.length - 1
      ? loadingText[loadingText.length - 1]
      : loadingText[textIndex];

  return (
    <div className="flex w-full flex-col items-center gap-2">
      <div className="w-full flex-1 flex items-center gap-4">
        <div className="w-44 xl:block hidden text-left text-12 text-white whitespace-nowrap">
          {text}
        </div>
        <LinearProgress
          variant="determinate"
          value={progressBarValue}
          className="!bg-white/10 rounded-full !h-3 w-full"
          sx={{
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#0DF9A4",
              borderTopRightRadius: "12px",
              borderBottomRightRadius: "12px",
            },
          }}
        />
        <div className="text-12">{percentageComplete}</div>
      </div>
      <div className="xl:hidden mt-2 block text-center text-12 text-white whitespace-nowrap">
        {text}
      </div>
    </div>
  );
};

export default ProgressBar;
